module.exports = __webpack_public_path__ + "img/all_c_70121.41ef8ea2.jpg";